"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var lodash_1 = require("lodash");
var Button_1 = require("../Button");
var TextInput_1 = require("../TextInput");
var AddressResults_1 = require("./AddressResults");
var AddressFinder = /** @class */ (function (_super) {
    __extends(AddressFinder, _super);
    function AddressFinder(props) {
        var _this = _super.call(this, props) || this;
        _this.manualClass = 'enter-manually form-group link small unstyled';
        _this.focusOnElement = function (querySelector) {
            if (_this.onRef && _this.onRef.current) {
                setTimeout(function () {
                    var el = _this.onRef.current.querySelector(querySelector);
                    if (el) {
                        el.focus();
                    }
                }, 50);
            }
        };
        _this.hasAddressErrors = function () {
            var errorsKeys = lodash_1.keys(_this.props.errors);
            return errorsKeys.reduce(function (acc, err) {
                return acc || (_this.props.errors != null &&
                    _this.props.errors[err] !== true);
            }, false);
        };
        _this.handleTermChange = function (event) {
            clearTimeout(_this.blurTimeout);
            _this.setState({ resultsVisible: true });
            _this.find(event.target.value);
        };
        _this.hideResults = function () {
            _this.setState({ resultsVisible: false });
        };
        _this.addressResults = function () { return React.createElement(AddressResults_1.default, { results: _this.state.findResults, searchTerm: _this.state.searchTerm, findOrRetrieve: _this.findOrRetrieve, trackAddress: _this.trackAddress, hideResults: _this.hideResults, setResultClicked: _this.setResultClicked }); };
        _this.setResultClicked = function (resultWasClicked) {
            _this.setState({ resultWasClicked: resultWasClicked });
        };
        _this.handleOnBlur = function (e) {
            _this.setResultClicked(false);
            var relatedTarget = e.relatedTarget;
            var relatedTargetIsResult = relatedTarget && relatedTarget.getAttribute('id') ?
                relatedTarget.getAttribute('id').match(/address-result-\d+/) : null;
            _this.blurTimeout = setTimeout(function () {
                if (_this.state.resultWasClicked || relatedTargetIsResult) {
                    return;
                }
                _this.hideResults();
            }, 200);
        };
        _this.handleKeyDown = function (event) {
            var keyName = event.key;
            switch (keyName) {
                case 'ArrowDown':
                    _this.focusOnElement('#address-result-0');
                    break;
                case 'Escape':
                    _this.hideResults();
                    break;
            }
        };
        _this.retrieve = function (id) {
            _this.props.api.retrieve(id).then(function (res) {
                if (!res.Items || !res.Items[0]) {
                    _this.setState({
                        findResults: undefined,
                        searchTermError: _this.props.label + " is invalid"
                    });
                }
                var address = _this.props.address;
                var yearsAtAddress = address && address.years_at_address ? address.years_at_address : undefined;
                var item = res.Items[0];
                var fullAddress = {
                    flat: item.SubBuilding,
                    house_number: item.BuildingNumber,
                    house_name: item.BuildingName,
                    street: item.Street,
                    district: item.District,
                    county: '',
                    town: item.City,
                    postcode: item.PostalCode,
                    years_at_address: yearsAtAddress
                };
                _this.props.handleChange({
                    target: {
                        name: _this.props.name,
                        value: fullAddress
                    }
                });
                setTimeout(function () {
                    if (!_this.props.validateAll(false)) {
                        _this.props.handleEnterManually(false);
                        return;
                    }
                }, 50);
                _this.props.setStage('selected');
            })
                .catch(function (error) { return console.error("Postcode Anywhere returned error code when searched for \"" + id + "\"", error); });
        };
        _this.findOrRetrieve = function (result) {
            if (result.Next === 'Retrieve') {
                _this.retrieve(result.Id);
            }
            else if (result.Next === 'Find') {
                _this.find(result.Text, result.Id);
            }
            else {
                console.error('Unhandled postcode "next"');
            }
        };
        _this.find = function (value, lastId) {
            _this.setState({
                searchTerm: value,
                searchTermError: undefined,
                findResults: undefined,
            });
            if (value === '') {
                return;
            }
            if (_this.timer != null) {
                clearTimeout(_this.timer);
            }
            _this.timer = setTimeout(function () {
                _this.props.api.find(value, lastId)
                    .then(function (res) {
                    var findResults = res;
                    if (_this.state.searchTerm !== value) {
                        return;
                    }
                    if (!res || !res.Items || !res.Items.length) {
                        findResults = undefined;
                    }
                    else if (lastId && res.Items.length === 1) {
                        _this.findOrRetrieve(res.Items[0]);
                        return;
                    }
                    _this.setState({
                        findResults: findResults,
                        focusedResult: 0,
                    });
                    _this.focusOnElement('#addresses\\.current_address\\.finder');
                })
                    .catch(function (error) { return console.error("Postcode Anywhere returned error code when searched for \"" + value + "\"", error); });
            }, 500);
        };
        _this.searchByPostcodeOrAddress = function (postcode) {
            var searchTerm = _this.state.searchTerm;
            return searchTerm && postcode.includes(searchTerm.toUpperCase());
        };
        _this.trackAddress = function (result) {
            var interactionsEvent = {
                target: {
                    eventName: 'Address',
                    action: _this.props.name,
                    label: _this.searchByPostcodeOrAddress(result.Text) ? 'Postcode' : 'Address line'
                }
            };
            if (typeof _this.props.track === 'function') {
                _this.props.track(interactionsEvent);
            }
        };
        _this.state = {
            resultsVisible: true,
            findResults: undefined,
            searchTermError: undefined,
            resultWasClicked: undefined,
        };
        _this.onRef = React.createRef();
        return _this;
    }
    AddressFinder.prototype.render = function () {
        var _a = this.props, name = _a.name, label = _a.label, _b = _a.disabled, disabled = _b === void 0 ? false : _b, errors = _a.errors, tooltip = _a.tooltip, handleEnterManually = _a.handleEnterManually;
        var nestedErrorsMessage;
        if (typeof errors !== 'string' && Object.keys(errors).length && this.hasAddressErrors()) {
            nestedErrorsMessage = React.createElement("span", null,
                "Please enter your ",
                React.createElement("strong", null, label));
        }
        return (React.createElement("div", { className: 'finder-wrapper', ref: this.onRef },
            React.createElement(TextInput_1.default, { name: name + ".finder", label: label, value: (!disabled) ? (this.state.searchTerm || '') : '', errors: (!disabled) ? (this.state.searchTermError || nestedErrorsMessage || '') : '', autoComplete: 'off', tooltip: tooltip, placeholder: (!disabled) ? 'Enter your postcode or address' : 'Previous address is not required', disabled: disabled, handleChange: this.handleTermChange, handleKeyDown: this.handleKeyDown, handleOnBlur: this.handleOnBlur }),
            (!disabled && this.state.searchTerm && this.state.resultsVisible) ? this.addressResults() : null,
            React.createElement(Button_1.default, { className: this.manualClass, handleClick: handleEnterManually, disabled: disabled }, "Enter Manually")));
    };
    return AddressFinder;
}(React.Component));
exports.default = AddressFinder;
